import * as types from 'constants/addInterview';
import {AjaxByToken,cancelRequestByKey,AjaxByGetByResumeClient} from 'utils/ajax';
// 显示增添面试官列表MODAL
const SHOW_ADDINTERVIEW_MODAL = {type:types.SHOW_ADDINTERVIEW_MODAL};
// 隐藏增添面试官列表MODAL
const HIDE_ADDINTERVIEW_MODAL = {type:types.HIDE_ADDINTERVIEW_MODAL};
// 发送请求开启
const START_ADDINTERVIEW_MODAL = {type:types.START_ADDINTERVIEW_MODAL};
// 发送请求结束
const DONE_ADDINTERVIEW_MODAL = {type:types.DONE_ADDINTERVIEW_MODAL};
// 显示增加面试官MODAL
const ADD_INTERVIEW_DATA={type:types.ADD_INTERVIEW_DATA};
// 面试官选中的list
const ADD_TAGLIST={type:types.ADD_TAGLIST};


export const hideAddInterviewModal = () => (dispatch,getState) => {
    dispatch(HIDE_ADDINTERVIEW_MODAL);
}



  // 显示面试官MODAL
export const showAddInterviewModal = () => (dispatch,getState) => {
    dispatch(SHOW_ADDINTERVIEW_MODAL);
}
// 调取面试官table-list数据接口
export const getAddInterviewsList = (skip,key)=> (dispatch,getState) => {
    const uri = 'getinterviewers';
    cancelRequestByKey(uri);
    dispatch(START_ADDINTERVIEW_MODAL);
    AjaxByToken(uri,{
        head: {
            transcode: 'L0105',
        },
        data:{
          skip:skip? skip :0,
          count:10,
          key
        }
    })
    .then(res=>{
      dispatch(DONE_ADDINTERVIEW_MODAL);
      dispatch({...ADD_INTERVIEW_DATA,addInterviewList:res.result});
  },err=>{
      dispatch(DONE_ADDINTERVIEW_MODAL);
  });
  }


// WEBPACK FOOTER //
// ./src/actions/addInterview.js